// extracted by mini-css-extract-plugin
export default {"flex":"PayOnDelivery_flex__yN-4g","container":"PayOnDelivery_container__zYUIl"};